export const content = {
  en: {
    meta: {
      title: "Coco Peat Exporter & Supplier in India | PPM Cocopeat",
      desc: "Wholesale supplier & exporter of low EC washed coco peat, 5kg coir pith blocks & buffered coir from India. Lab-tested, MSME & RCMC certified. Request a quote."
    },
    nav: { home: "Home", about: "About", products: "Products", blog: "Blog", contact: "Contact", location: "Location" },
    hero: {
      title: "Export-Grade Coco Peat & Coir Blocks from India",
      subtitle: "Low EC washed coco peat, buffered coir & 5kg blocks — lab-tested and shipped worldwide by container. MSME & RCMC certified exporter.",
      cta: "Get a Free Quote"
    },
    certifications: "Certified & Recognized By:",
    about: {
      title: "About PPM Cocopeat",
      desc: "PPM Cocopeat is a government-registered (MSME & RCMC certified) exporter of sustainable coir substrates from India. We supply lab-tested low EC coco peat, buffered coir and 5kg coir pith blocks to commercial greenhouses, nurseries, hydroponic farms and soil blenders across South Korea, Europe, the USA, Australia and New Zealand — with full phytosanitary and fumigation documentation on every container.",
      tagline: "100% Organic • Lab-Tested Low EC • Container Export Ready"
    },
    products: {
      title: "Our Coco Peat & Coir Products",
      specSheet: "Download Full Specification Sheet (PDF)",
      items: [
        {
          name: "Washed Low EC Coco Peat Blocks (5kg)",
          desc: "Fresh-water washed coir pith compressed into 5kg blocks. Low EC (<0.5 mS/cm), pH 5.5–6.8, expands to 75–80 litres. High water retention and excellent aeration for nurseries and open-field agriculture.",
          use: "Best for: Potting Soil, Nurseries, Landscaping, Soil Conditioning",
          hsn: "53050040",
          img: "/assets/coco-block.jpeg"
        },
        {
          name: "Buffered Coir Blocks, Grow Bags & Slabs",
          desc: "Calcium-nitrate buffered to displace sodium & potassium and prevent nutrient lock-out. Ultra-low EC (<0.8 mS/cm), pH 5.8–6.5, stable structure — the professional standard for hydroponic tomatoes, cucumbers, capsicum and berries.",
          use: "Best for: Greenhouse Hydroponics, Professional Grow Bags, Sensitive Crops",
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg"
        }
      ]
    },
    form: {
      title: "Send an Enquiry",
      subtitle: "Fill out the form below and we will get back to you with a CIF/FOB quote.",
      fields: {
        name: "Full Name",
        phone: "Phone Number",
        address: "Your Address",
        country: "Country",
        email: "Email Address",
        message: "Message / Specific Requirements"
      },
      submit: "Send Enquiry",
      sending: "Sending…",
      success: "Thank you! Your enquiry has been received. Our team will reply with a quote within 24 hours.",
      error: "We opened your email app as a backup — please press send there, or WhatsApp us."
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What is the minimum order quantity (MOQ) for coco peat?",
          a: "Our standard MOQ is one full 40ft High Cube container — roughly 4,400–5,000 x 5kg blocks depending on whether it's floor-loaded or palletized. Contact us for consolidated or trial-volume options."
        },
        {
          q: "Do you provide samples before a bulk order?",
          a: "Yes. We ship a sample block of your chosen grade together with a lab report (EC, pH, moisture, impurity) so you can verify quality before committing to a container."
        },
        {
          q: "What is the EC and pH of your coco peat?",
          a: "Our washed low-EC blocks are below 0.5 mS/cm with pH 5.5–6.8, and our fully calcium-buffered coir is below 0.8 mS/cm with pH 5.8–6.5. Every shipment includes a batch-specific lab report."
        },
        {
          q: "Which countries do you export to?",
          a: "We export worldwide, with regular shipments to South Korea, the Netherlands and Europe, the United States, Australia and New Zealand. We quote FOB from Indian ports or CIF to your destination port."
        },
        {
          q: "What documents come with each shipment?",
          a: "Every container includes a commercial invoice, packing list, certificate of origin, phytosanitary certificate, fumigation certificate and a lab test report — under HS code 53050040."
        },
        {
          q: "Do you offer CIF or FOB pricing?",
          a: "Both. Share your destination port and target volume and we'll return transparent FOB and CIF quotes with lead times."
        }
      ]
    },
    location: {
      title: "Visit Us",
      address_title: "Factory Address:",
      address: "PPM, Patparganj Industrial Area, Delhi-110092, India"
    }
  },
  es: {
    meta: {
      title: "Principal Exportador y Proveedor de Fibra de Coco en India | PPM",
      desc: "Exportador certificado de bloques de fibra de coco y sustrato orgánico premium de la India. Certificado MSME y RCMC."
    },
    nav: { home: "Inicio", about: "Nosotros", products: "Productos", blog: "Blog", contact: "Contacto", location: "Ubicación" },
    hero: {
      title: "El Mejor Sustrato de la Naturaleza",
      subtitle: "Bloques de Fibra de Coco y Sustrato Premium para Exportación Global.",
      cta: "Solicitar Cotización"
    },
    certifications: "Certificado y Reconocido Por:",
    about: {
      title: "Sobre PPM",
      desc: "PPM es un exportador registrado de sustratos orgánicos sostenibles de la India. Suministramos bloques de fibra de coco de alta calidad a viveros y cultivos hidropónicos.",
      tagline: "100% Orgánico • Ecológico • Sostenible"
    },
    products: {
      title: "Nuestros Productos",
      items: [
        { 
          name: "Bloques de Fibra de Coco (Lavado)", 
          desc: "Bloques de coco estándar lavados. Alta retención de agua, baja conductividad eléctrica (EC) y excelente aireación.", 
          use: "Ideal para: Tierra para macetas, Paisajismo", 
          hsn: "53050040",
          img: "/assets/coco-block.jpeg" 
        },
        { 
          name: "Bloques de Coco Tamponados (Buffered)", 
          desc: "Tratados con Nitrato de Calcio para eliminar sodio. EC muy baja, pH equilibrado.", 
          use: "Ideal para: Hidroponía, Bolsas de cultivo", 
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg" 
        }
      ]
    },
    form: {
      title: "Envíe una Consulta",
      subtitle: "Complete el formulario para recibir una cotización CIF/FOB.",
      fields: { name: "Nombre Completo", phone: "Teléfono", address: "Dirección", country: "País", email: "Correo Electrónico", message: "Mensaje" },
      submit: "Enviar Consulta"
    },
    location: { title: "Visítenos", address_title: "Dirección de Fábrica:", address: "PPM, Patparganj Industrial Area, Delhi-110092, India" }
  },
  nl: {
    meta: {
      title: "Top Exporteur & Leverancier van Kokosgruis in India | PPM",
      desc: "Gecertificeerde exporteur van premium organische kokosgruis en kokossubstraten uit India. MSME & RCMC gecertificeerd."
    },
    nav: { home: "Home", about: "Over ons", products: "Producten", blog: "Blog", contact: "Contact", location: "Locatie" },
    hero: {
      title: "Het Beste Substraat van de Natuur",
      subtitle: "Premium Organische Kokosgruis & Kokosblokken voor Wereldwijde Export.",
      cta: "Offerte Aanvragen"
    },
    certifications: "Gecertificeerd en Erkend Door:",
    about: {
      title: "Over PPM",
      desc: "PPM is een geregistreerde exporteur van duurzame substraten uit India. Wij leveren hoogwaardige kokosgruis (cocopeat) aan kwekerijen wereldwijd.",
      tagline: "100% Organisch • Milieuvriendelijk • Duurzaam"
    },
    products: {
      title: "Onze Producten",
      items: [
        { 
          name: "Gewassen Kokosgruis (Coco Peat)", 
          desc: "Standaard gewassen kokosblokken. Hoge waterretentie en uitstekende luchtigheid.", 
          use: "Geschikt voor: Potgrond, Bodemverbetering", 
          hsn: "53050040",
          img: "/assets/coco-block.jpeg" 
        },
        { 
          name: "Gebufferde Kokosblokken", 
          desc: "Behandeld met Calciumnitraat. Zeer lage EC, pH-gebalanceerd.", 
          use: "Geschikt voor: Hydrocultuur, Kwekerijen", 
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg" 
        }
      ]
    },
    form: {
      title: "Stuur een Aanvraag",
      subtitle: "Vul het formulier in voor een prijsopgave.",
      fields: { name: "Volledige Naam", phone: "Telefoonnummer", address: "Uw Adres", country: "Land", email: "E-mailadres", message: "Bericht" },
      submit: "Verstuur via E-mail"
    },
    location: { title: "Bezoek Ons", address_title: "Fabrieksadres:", address: "PPM, Patparganj Industrial Area, Delhi-110092, India" }
  },
  fr: {
    meta: {
      title: "Premier Exportateur et Fournisseur de Tourbe de Coco en Inde | PPM",
      desc: "Exportateur certifié de blocs de tourbe de coco organique et de substrats d'Inde. Certifié MSME et RCMC."
    },
    nav: { home: "Accueil", about: "À propos", products: "Produits", blog: "Blog", contact: "Contact", location: "Lieu" },
    hero: {
      title: "Le Meilleur Substrat Naturel",
      subtitle: "Blocs de Tourbe de Coco (Coco Peat) Premium pour l'Exportation Mondiale.",
      cta: "Demander un Devis"
    },
    certifications: "Certifié et Reconnu Par:",
    about: {
      title: "À propos de PPM",
      desc: "PPM est un exportateur indien de tourbe de coco (moelle de coco) de haute qualité pour les pépinières et fermes hydroponiques du monde entier.",
      tagline: "100% Biologique • Écologique • Durable"
    },
    products: {
      title: "Nos Produits",
      items: [
        { 
          name: "Tourbe de Coco Lavée (Washed)", 
          desc: "Blocs de moelle de coco lavés standard. Haute rétention d'eau et excellente aération.", 
          use: "Idéal pour : Terreau, Aménagement paysager", 
          hsn: "53050040",
          img: "/assets/coco-block.jpeg" 
        },
        { 
          name: "Blocs de Coco Tamponnés (Buffered)", 
          desc: "Traités au nitrate de calcium. EC très faible, pH équilibré.", 
          use: "Idéal pour : Hydroponie, Pépinières", 
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg" 
        }
      ]
    },
    form: {
      title: "Envoyer une Demande",
      subtitle: "Remplissez le formulaire ci-dessous pour obtenir un devis CIF/FOB.",
      fields: { name: "Nom Complet", phone: "Téléphone", address: "Votre Adresse", country: "Pays", email: "Adresse Email", message: "Message" },
      submit: "Envoyer par Email"
    },
    location: { title: "Visitez-nous", address_title: "Adresse de l'usine:", address: "PPM, Patparganj Industrial Area, Delhi-110092, India" }
  },
  cn: {
    meta: {
      title: "印度顶尖椰糠和椰壳纤维出口商与供应商 | PPM",
      desc: "来自印度的优质有机椰糠 (Coco Peat) 砖认证出口商。拥有 MSME 和 RCMC 认证。"
    },
    nav: { home: "首页", about: "关于我们", products: "产品", blog: "博客", contact: "联系我们", location: "位置" },
    hero: {
      title: "大自然的最佳基质",
      subtitle: "优质有机椰糠 (Coco Peat) 砖，面向全球出口。",
      cta: "获取报价"
    },
    certifications: "认证与认可:",
    about: {
      title: "关于 PPM",
      desc: "PPM 是印度政府注册的出口商，为世界各地的苗圃和水培农场提供高质量的椰糠和椰壳纤维块。",
      tagline: "100% 有机 • 环保 • 可持续"
    },
    products: {
      title: "我们的产品",
      items: [
        { 
          name: "水洗椰糠砖 (Washed Coco Peat)", 
          desc: "标准水洗椰糠块。高保水性，低EC值，优良的透气性。", 
          use: "适用于：盆栽土，园林绿化", 
          hsn: "53050040",
          img: "/assets/coco-block.jpeg" 
        },
        { 
          name: "缓冲处理椰糠砖 (Buffered)", 
          desc: "经过硝酸钙缓冲处理。超低EC值，pH平衡。", 
          use: "适用于：水培，专业种植袋", 
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg" 
        }
      ]
    },
    form: {
      title: "发送询价",
      subtitle: "填写下表，我们将为您提供 CIF/FOB 报价。",
      fields: { name: "全名", phone: "电话号码", address: "您的地址", country: "国家", email: "电子邮件", message: "信息 / 具体规格要求" },
      submit: "通过电子邮件发送"
    },
    location: { title: "访问我们", address_title: "工厂地址:", address: "PPM, Patparganj Industrial Area, Delhi-110092, India" }
  },
  ko: {
    meta: {
      title: "인도의 최고 코코피트 및 코코아 껍질 수출업체 및 공급업체 | PPM",
      desc: "인도산 프리미엄 유기농 코코피트 및 완충 코코 블록 인증 수출 업체. MSME 및 RCMC 인증."
    },
    nav: { home: "홈", about: "소개", products: "제품", blog: "블로그", contact: "문의", location: "위치" },
    hero: {
      title: "자연이 주는 최고의 배양토",
      subtitle: "전 세계 수출을 위한 프리미엄 유기농 코코피트 및 코코아 껍질 블록.",
      cta: "견적 요청"
    },
    certifications: "인증 및 인정:",
    about: {
      title: "PPM 소개",
      desc: "PPM은 인도의 지속 가능한 유기농 배양토 수출업체입니다. 전 세계 묘목장 및 수경 재배 농장에 고품질 코코피트 블록을 제공합니다.",
      tagline: "100% 유기농 • 친환경 • 지속 가능"
    },
    products: {
      title: "제품 소개",
      items: [
        {
          name: "세척 코코피트 (Washed Coco Peat)",
          desc: "표준 세척 코코피트 블록. 높은 수분 유지력, 낮은 EC, 일반 원예 및 노지 농업을 위한 탁월한 통기성.",
          use: "용도: 화분 흙, 조경, 토양 개량",
          hsn: "53050040",
          img: "/assets/coco-block.jpeg"
        },
        {
          name: "버퍼링 코코 블록 (Buffered)",
          desc: "나트륨과 칼륨을 제거하기 위해 질산칼슘으로 화학 처리됨. 매우 낮은 EC, pH 균형 및 안정적인 구조.",
          use: "용도: 수경 재배, 전문 재배 가방, 민감한 작물",
          hsn: "53050040",
          img: "/assets/coco-brick.jpeg"
        }
      ]
    },
    form: {
      title: "문의하기",
      subtitle: "아래 양식을 작성해 주시면 CIF/FOB 견적을 보내드립니다.",
      fields: {
        name: "성함",
        phone: "전화번호",
        address: "주소",
        country: "국가",
        email: "이메일 주소",
        message: "메시지 / 세부 요구 사항"
      },
      submit: "이메일로 문의 보내기"
    },
    location: {
      title: "오시는 길",
      address_title: "공장 주소:",
      address: "PPM, Patparganj Industrial Area, Delhi-110092, India"
    }
  }
};